export default __webpack_public_path__ + "static/media/play-badge.23f2426b.svg";